export default __webpack_public_path__ + "static/odpc-036ac50e369777796e24d2d07b94e97a.png";